import { __assign, __awaiter, __generator } from "tslib";
export var serializerMiddleware = function serializerMiddleware(options, serializer) {
  return function (next, context) {
    return function (args) {
      return __awaiter(void 0, void 0, void 0, function () {
        var logger, inputFilterSensitiveLog, request;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logger = context.logger, inputFilterSensitiveLog = context.inputFilterSensitiveLog;

              if (typeof (logger === null || logger === void 0 ? void 0 : logger.info) === "function") {
                logger.info({
                  input: inputFilterSensitiveLog(args.input)
                });
              }

              return [4
              /*yield*/
              , serializer(args.input, options)];

            case 1:
              request = _a.sent();

              if (typeof (logger === null || logger === void 0 ? void 0 : logger.debug) === "function") {
                logger.debug({
                  httpRequest: request
                });
              }

              return [2
              /*return*/
              , next(__assign(__assign({}, args), {
                request: request
              }))];
          }
        });
      });
    };
  };
};